import { render, staticRenderFns } from "./InformationEdit.vue?vue&type=template&id=23957913&scoped=true&"
import script from "./InformationEdit.vue?vue&type=script&lang=js&"
export * from "./InformationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23957913",
  null
  
)

export default component.exports